const PARTNER_SETTINGS_GETTERS = {
  settings: 'partnerSettings/settings',
  loading: 'partnerSettings/loading',
}

const PARTNER_SETTINGS_DISPATCHERS = {
  getPartnerSettings: 'partnerSettings/getPartnerSettings',
}

export { PARTNER_SETTINGS_GETTERS, PARTNER_SETTINGS_DISPATCHERS }
